import React, { type ReactNode } from "react";

/**
 * For non-string `children`, return as-is or wrap primitives that are not passed straight
 * through. `Button` / `LinkButton` pass string and number children directly to S2 so the
 * built-in label `Text` (vertical padding) applies; use a fragment or element child if a
 * button sits inside a RAC field and slotted `Text` throws.
 */
export function s2UnslottedLabel(children: ReactNode): ReactNode {
  if (typeof children === "string" || typeof children === "number") {
    return <span>{children}</span>;
  }
  return children;
}
